export default class NavigationAdapter {
	constructor({ swup } = {}) {
		this.swup = swup || null
		this.popListeners = new Set()
		this.onPop = this.onPop.bind(this)

		this._index = window.history.state?.__idx ?? 0

		window.addEventListener('popstate', this.onPop)
	}

	getUrl() {
		return window.location.href
	}

	getIndex() {
		return this._index
	}

	push(url, state = {}) {
		this._index += 1
		const nextState = this.swup ? { ...state, __idx: this._index, swup: true } : { ...state, __idx: this._index }
		window.history.pushState(nextState, '', url)
	}

	replace(url, state = {}) {
		const nextState = this.swup ? { ...state, __idx: this._index, swup: true } : { ...state, __idx: this._index }
		window.history.replaceState(nextState, '', url)
	}

	go(delta) {
		window.history.go(delta)
	}

	onPopState(cb) {
		this.popListeners.add(cb)
	}

	offPopState(cb) {
		this.popListeners.delete(cb)
	}

	onPop(e) {
		this._index = e.state?.__idx ?? this._index
		this.popListeners.forEach((cb) => cb(e))
	}
}
